export const DATABASE_CONTENT_TYPE = 'database';

// Public macros
export const DATABASE_MACRO_KEY = 'orderly-database';
export const DATABASE_ENTRY_MACRO_KEY = 'orderly-database-entry';
export const DATABASE_VALUE_MACRO_KEY = 'orderly-database-value';

// Internal macros
export const DB_MACRO_KEY = 'orderly-db';
export const DB_FIELD_MACRO_KEY = 'orderly-db-field';
export const DB_ENTRY_MACRO_KEY = 'orderly-db-entry';
export const DB_VALUE_MACRO_KEY = 'orderly-db-value';

export const DEFAULT_VIEW_NAME = 'View';

/** Columns in table view mode cannot be resized to anything more narrow than this */
export const TABLE_VIEW_HARD_COLUMN_MIN_WIDTH = 85;
/** Columns in table view mode with undefined width will have this minimum width applied */
export const TABLE_VIEW_SOFT_COLUMN_MIN_WIDTH = 200;

/** Number of times that a database value may reference another database value before breaking the recursion */
export const RECURSION_LIMIT = 10;
